{
  "name": "angular-starter",
  "private": true,
  "version": "4.2.93",
  "scripts": {
    "ng": "ng",
    "build_production": "ng build --optimization --aot --configuration production",
    "build_staging": "ng build --optimization --aot --configuration staging",
    "build_training": "ng build --optimization --aot --configuration training",
    "check:dep": "npx depcheck",
    "lint-fix": "ng lint --fix",
    "precommit": "lint-staged",
    "prettier:check": "prettier --check **/**/*.{json,css,js,yml,yaml,md}",
    "prettier:format": "npx prettier --write .",
    "start": "ng serve",
    "test": "ng test",
    "test:prod": "ng build && http-server -c-1 dist/",
    "watch": "ng build --watch --configuration development",
    "build:tailwind": "npx tailwindcss -c ./tailwind.config.js -i ./public/css/tailwind.css -o ./public/css/tailwind.out.css --watch",
    "lint": "ng lint",
    "prepare": "husky"
  },
  "lint-staged": {
    "*.{js,ts,tsx}": [
      "npx eslint",
      "npm run prettier:format"
    ]
  },
  "dependencies": {
    "@angular/animations": "^20.0.0",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.0.0",
    "@angular/compiler": "^20.0.0",
    "@angular/core": "^20.0.0",
    "@angular/forms": "^20.0.0",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.0.0",
    "@angular/router": "^20.0.0",
    "@angular/service-worker": "^20.0.0",
    "@fortawesome/fontawesome-free": "^7.1.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "angularx-qrcode": "^20.0.0",
    "husky": "^9.1.7",
    "rxjs": "^7.8.1",
    "tslib": "^2.5.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.0.0",
    "@angular/cli": "^20.0.0",
    "@angular/compiler-cli": "^20.0.0",
    "@types/node": "^24.10.1",
    "autoprefixer": "^10.4.22",
    "postcss": "^8.5.6",
    "tailwindcss": "^3.4.18",
    "typescript": "^5.8.2"
  }
}
